export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
export const FIRSTVOICESLINK = 'firstvoices.com'
export const NOTIFICATION_TIME = 4000
export const DISPLAYABLE_PROPS_MEDIA = [
  'filename',
  'title',
  'mimeType',
  'acknowledgement',
  'description',
  'dimensions',
  'speakers',
  'created',
]
export const ABOUT_LINK =
  'https://firstvoices.atlassian.net/wiki/spaces/FIR1/pages/1704813/About+FirstVoices'
export const SUPPORT_LINK =
  'https://firstvoices.atlassian.net/servicedesk/customer/portals'

// the key for storing a post-login redirect location
export const ORIGINAL_DESTINATION = 'original_destination'
